export default __webpack_public_path__ + "static/media/Group1.67dfab67.svg";